import * as tslib_1 from "tslib";
var RastreamentoController = /** @class */ (function () {
    function RastreamentoController($stateParams, $state, $timeout, $filter, Rastreamento, Auth) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.Rastreamento = Rastreamento;
        this.Auth = Auth;
        this.infoRastreio = "Por favor aguarde, estamos buscando as informações da sua encomenda...";
        this.alerts = [];
        this.mostrarDetalhes = false;
        this.mostrarDetalhesReversa = false;
        this.emailVero = false;
    }
    RastreamentoController.prototype.$onInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status_1, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.numeroRastreio = this.$stateParams.numeroRastreio;
                        // This page is part of the signed-in app: without a session the user signs in first.
                        if (!this.isLoggedIn()) {
                            window.location.href = "/login";
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.Rastreamento.getRastreio(this.numeroRastreio)];
                    case 2:
                        status_1 = _a.sent();
                        if (status_1.redirecionamento) {
                            window.open(status_1.urlRedirecionamento, "_self");
                        }
                        else {
                            this.ajustaColuna =
                                this.$filter("filter")(status_1.historico, { exibirAlerta: true })
                                    .length > 0;
                            this.encomenda = status_1;
                            if (this.encomenda.destinatario.email) {
                                this.encomenda.destinatario.textoBotao = "Alterar";
                            }
                            this.mostrarDetalhes =
                                this.encomenda.servicoEnvio !== "Logistica Reversa";
                            this.mostrarDetalhesReversa =
                                this.encomenda.servicoEnvio === "Logistica Reversa";
                            this.setAnalytics();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1.status === 404) {
                            this.infoRastreio = "Número de rastreamento não encontrado.";
                        }
                        else {
                            this.infoRastreio =
                                "Não foi possível obter os dados do rastreamento. Por favor tente novamente.";
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RastreamentoController.prototype.isLoggedIn = function () {
        return this.Auth.isLoggedIn();
    };
    RastreamentoController.prototype.close = function () {
        this.emailVero = false;
    };
    RastreamentoController.prototype.closeAlert = function (index) {
        this.alerts.splice(index, 1);
    };
    RastreamentoController.prototype.enviarEmail = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var properties, err_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        properties = {
                            nomeDestinatario: this.encomenda.destinatario.nome,
                            emailDestinatario: this.encomenda.destinatario.email,
                            nomeRemetente: this.encomenda.remetente.nome,
                            emailRemetente: this.Auth.getCurrentUser().email,
                            codigoRastreamento: this.numeroRastreio,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.Rastreamento.putEmailDestinatario({
                                codigoRastreamento: properties.codigoRastreamento,
                                novoEmail: properties.emailDestinatario,
                            })];
                    case 2:
                        _a.sent();
                        if (properties.emailDestinatario) {
                            this.emailVero = true;
                            $("html, body").animate({ scrollTop: 0 }, 500);
                            this.$timeout(function () {
                                _this.emailVero = false;
                            }, 7000);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.addAlert("Não foi possível atualizar o email, por favor tente novamente.");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RastreamentoController.prototype.mudouDataExibicao = function (index) {
        if (!index) {
            return true;
        }
        var dataIteracaoAtual = this.$filter("date")(this.encomenda.historico[index].dataHoraTs, "dd-MM-yyyy");
        var dataIteracaoAnterior = this.$filter("date")(this.encomenda.historico[index - 1].dataHoraTs, "dd-MM-yyyy");
        return dataIteracaoAtual !== dataIteracaoAnterior;
    };
    RastreamentoController.prototype.addAlert = function (message) {
        var _this = this;
        this.alerts.push({
            type: "danger",
            msg: message,
        });
        $("html, body").animate({ scrollTop: 0 }, 500);
        this.$timeout(function () {
            _this.closeAlert(0);
        }, 7000);
    };
    RastreamentoController.prototype.setAnalytics = function () {
        var obj = {
            url: "/" + this.$state.current.name,
            email: this.Auth.getCurrentUser().email,
            loggedIn: this.isLoggedIn(),
            codigoRastreamento: this.numeroRastreio,
            RecipientCity: this.encomenda
                ? this.encomenda.destinatario.endereco.cidade
                : null,
            RecipientState: this.encomenda
                ? this.encomenda.destinatario.endereco.uf
                : null,
        };
    };
    return RastreamentoController;
}());
export { RastreamentoController };
//# sourceMappingURL=rastreamento.controller.js.map